import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import { selectedNewsSelector } from 'src/store/news';

import { ROUTE } from 'src/constants';

import { CustomButton, WhiteCard } from 'src/components';

import { ReactComponent as Arrow } from 'src/assets/overall/Arrow.svg';
import './viewNews.scss';

export const ViewNews = () => {
  const { t } = useTranslation('news');

  const navigate = useNavigate();

  const selectedNews = useSelector(selectedNewsSelector);

  const onClickBack = useCallback(() => {
    navigate(ROUTE.NEWS.MAIN);
  }, [navigate]);

  return (
    <div className="view-news">
      <div className="view-news__header">
        <CustomButton
          title={t('title:previous')}
          variant="outlined"
          onClick={onClickBack}
          icon={<Arrow />}
        />
        <h2>{t('title')}</h2>
      </div>

      <div className="view-news__content">
        <div className="view-news__left">
          <img
            className="view-news__left__image"
            src={selectedNews?.image}
            alt={selectedNews?.image}
          />
        </div>
        <div className="view-news__right">
          <div className="view-news__right__date">
            {moment(selectedNews?.created).format('DD.MM.YYYY, HH:mm')}
          </div>
          <h3 className="view-news__right__title">{selectedNews?.title}</h3>
          <WhiteCard>{selectedNews?.description}</WhiteCard>
        </div>
      </div>
    </div>
  );
};
